/**
 * @file   src\mobile\components\CreateInventory\ProgressBarInventory.js
 * @brief  This file is responsible for progressbar shown in create inventory
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { INVENTORY_KEY, INVENTORY_KEY_TEMP } from "../../../constants/common";
import { pageURLs } from "@/constants";
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "../../../helpers/common";
import BottomStepperMob from "../BottomStepperMob";
import { useNavigate } from "react-router-dom";
import TopHeader from '../common/TopHeader';

const ProgressBarInventory = (props) => {
  const navigate = useNavigate();
  const { completedPercentage, setUIKey, uiKey, isPremiumUser, isEdit } = props;
  const formValues = getLocalStorage(INVENTORY_KEY);
  /**
   * To handle backbutton in progressbar secion
   */
  const handleBackButtonClick = () => {
    setLocalStorage(INVENTORY_KEY_TEMP, getLocalStorage(INVENTORY_KEY));
    if (
      uiKey === "client" &&
      (!formValues || !formValues?.prprtyType || !formValues?.locAddress)
    ) {
      removeLocalStorage(INVENTORY_KEY);
      removeLocalStorage(INVENTORY_KEY_TEMP);
      navigate(pageURLs.mobileHome);
    } else if (
      uiKey === "propertyType" &&
      (!formValues?.prprtyType || !formValues?.locAddress)
    ) {
      if (isPremiumUser) {
        setUIKey("client");
      } else {
        navigate(pageURLs.mobileHome);
      }
    } else if (uiKey === "location" && formValues?.locAddress == undefined) {
      setUIKey("propertyType");
    } else if (uiKey === "readyToPost") {
      setUIKey("description");
    } else {
      setUIKey(null);
    }
  };

  return (
    <TopHeader
      variant="threeComp"
      outerClassname="bg-white"
      topClassName="w-100 flex-column"
      bottomClassName="w-100"
    >
      <a
        className={`d-block back-link-big ${isPremiumUser ? 'back-link-big-premium' : ''} me-4`}
        href={void 0}
        onClick={() => handleBackButtonClick()}
      >
        back
      </a>
      {!isEdit && (
        <div className="progress-wrap-mob">
          <BottomStepperMob completedPercentage={completedPercentage} />
        </div>
      )}
      <button
        className="btn top-exit-btn ms-4"
        onClick={() => {
          if (uiKey === "readyToPost") {
            setUIKey(null);
          } else {
            navigate(pageURLs.mobileHome);
          }
        }}
      >
        {uiKey === "readyToPost" ? "Edit" : "Exit"}
      </button>
    </TopHeader>
  );
};

export default ProgressBarInventory;
